import { Injectable } from '@angular/core';
import { NavigationExtras, Params } from '@angular/router';
import { compact, extend } from 'lodash';
import { IRouter } from '../../interfaces/router.interface';

const Url = require('domurl');

@Injectable()
export class UrlService {
  constructor() {}

  serializeParams(params: {}, prefix?: string): string {
    const str = [];

    for (const p in params) {
      if (params.hasOwnProperty(p)) {
        const k = prefix ? prefix + '[' + p + ']' : p;
        const v = params[p];

        str.push(
          typeof v === 'object'
            ? this.serializeParams(v, k)
            : encodeURIComponent(k) + '=' + encodeURIComponent(v)
        );
      }
    }

    return compact(str).join('&');
  }

  parse(url: string) {
    return new Url(url);
  }

  parseUrlToRoute(url: string, navigationExtras?: NavigationExtras): IRouter {
    const parsedUrl = this.parse(url);
    const extras = extend({}, navigationExtras || {}, {
      queryParams: parsedUrl.query || {},
    });

    return {
      route: parsedUrl.paths(),
      navigationExtras: extras,
    };
  }

  /**
   * Append query params to url
   *
   * ```
   * const url = http://billing.2go.com?eaid=1234
   * const queryParams = { promo: 'WBR50' };
   * const updatedUrl = appendQueryParams(url, queryParams);
   *
   * // updatedUrl
   * // http://billing.2go.com?eaid=1234&promo=WBR50
   * ```
   *
   * @param url
   * @param queryParams
   */
  appendQueryParams(url: string, queryParams: Params) {
    const parsedUrl = this.parse(url);

    Object.keys(queryParams).forEach((key) => {
      parsedUrl.query[key] = queryParams[key];
    });

    return parsedUrl.toString();
  }
}
